import React from 'react';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import * as fileCrud from '../../../../crud/file.crud';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { subYears } from 'date-fns';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';


class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);

        this.replyOptions = props.placeholders.find(ph => ph.replacementKey === 'NonConformityReplyOptions')
            .values.filter(item => item.isActive === true);


        this.replyFormConfig = {
            fields: [
                { label: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.STATUS' }), dataField: 'replystatus', editorType: 'dxSelectBox', editorOptions: { dataSource: this.replyOptions, valueExpr: 'field', displayExpr: 'display' } },
                { resource: "GENERAL.FORMS.FIELD.COMMENTS", dataField: 'replycomment', editorType: 'dxHtmlEditor' },
                { resource: 'CONTRACT.WF.DEFECTS.FIELD.CLOSE_DATE', dataField: 'replyaction', editorType: 'dxDateBox', editorOptions: { calendarOptions: { min: subYears(new Date(), 20), max: new Date() } }, validation: { type: 'range', min: subYears(new Date(), 20), max: new Date(), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE_FUTURE" }) } },
            ]
        };
    }




    renderForm = () => {
        return (
            <>
                {
                    this.props.resources.NCProposalReplyWarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.NCProposalReplyWarningBanner}
                            </p>
                        </Alert>
                    )
                }
                <BiDynamicForm
                    isReply={true}
                    item={this.props.reply}
                    config={this.replyFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFields || {}).REPLY}
                />
            </>
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.inspectiondefectid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {

        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;


        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFields || {}).REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );
    }
}

export default injectIntl(ReplyDocument);
